export default [{
  path: '/simulador-baixas',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Simulador de Baixas Histórico',
      path: 'historico',
      component: () => import('@/views/simuladorBaixas/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Simulação de Baixas' }
        ]
      }
    },
    {
      name: 'Simulador de Baixas Editar',
      path: 'edit/:id',
      component: () => import('@/views/simuladorBaixas/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Simulação de Baixas', path: '/simulador-baixas/historico' },
          { name: 'Editar' }
        ]
      }
    },
    {
      name: 'Simulador de Baixas Adicionar',
      path: 'edit',
      component: () => import('@/views/simuladorBaixas/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Simulação de Baixas', path: '/simulador-baixas/historico'},
          { name: 'Adicionar' }
        ]
      }
    }
  ]
}]